module.exports = __webpack_public_path__ + "img/jntcargo.641ab55d.png";